export default __webpack_public_path__ + "static/media/02-stop smoking.f1e51bea.svg";